import React from "react";
import { Link } from "react-router-dom";
import BusinessTypeList from "../../components/Master/BusinessTypeList";


const BusinessTypeListt = () => {
    return (
        <>
            <div className="breadcrumb-card">
                <h5>Business Type List</h5>

                <ul className="breadcrumb">
                    <li>
                        <Link to="/dashboard/ecommerce/">
                            <i className="material-symbols-outlined">home</i>
                            Dashboard
                        </Link>
                    </li>
                    <li>Master</li>
                    <li>Business Type List</li>
                </ul>
            </div>

            <BusinessTypeList />
        </>
    );
}
export default BusinessTypeListt;
